<template>

  <div class="card mt-2" id="instancer">
    <header class="card-header">
      <p class="card-header-title">
        <b-icon icon="power-off" />
        Challenge Instance
      </p>
       <span class="card-header-icon" aria-label="more options">
         <b-button type="is-small" :loading="loading" icon-left="sync" @click="update"></b-button>
        </span>
    </header>
    <div class="card-content">
      <b-loading v-model="loading" :is-full-page="false" />
      <div class="content">
        <div v-if="isStopped">
          <p align=center class="mb-3">
          <b-icon icon="server" class="mr-2" />
          No Instance Running
          </p>
        </div>
        <div class="mb-3" v-else>
        <div class="content">
          <b-taglist attached class="is-justify-content-center">
            <b-tag size="is-medium" type=""><span :class='["status", data.time_left === 0 ? "error" : "ok"]' aria-hidden="true"></span></b-tag>
            <b-tag size="is-medium" type="" v-if="data.name">instance-{{ data.name }}</b-tag>
            <b-tag size="is-medium" type="is-light" v-if="data.time_left"><b-icon icon="stopwatch" class="pr-5 pl-3"/>{{ formattedTimeLeft }}</b-tag>
          </b-taglist>
        </div>
        <div v-if="data.conn_info">
          <div class="box has-text-centered is-size-7" v-if="!data.conn_info_format">
            {{ data.conn_info }}
          </div>
          <div v-else class="box has-text-centered is-size-7" v-html="data.conn_info_format.replace(/{conn_info}/g, data.conn_info)"></div>
        </div>
        </div>
        <section class="columns is-gapless">
         <div class="column m-1"> <b-button expanded type="is-primary" :disabled="!isStopped" icon-left="play" @click="start">Start</b-button> </div>
         <div class="column m-1"> <b-button expanded type="is-danger" :disabled="isStopped" icon-left="stop" @click="destroy">Destroy</b-button> </div>
         <div class="column m-1"> <b-button expanded type="is-secondary" :disabled="isStopped" icon-left="stopwatch" @click="refresh">Refresh</b-button> </div>
        </section>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      name: this.$route.params.challenge_name,
      data: {
        name: null,
        conn_info: null,
        conn_info_format: null,
        time_left: null,
      },
      loading: false,
      interval: null,
      start_interval: null,
      seconds_interval: null,
    };
  },
  computed: {
    isStopped() { return Object.keys(this.data).length === 0; },
    formattedTimeLeft() {
      const seconds = Math.max(0, Math.floor(this.data.time_left || 0));
      if (seconds < 60) {
        return `${seconds}s`;
      }
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      if (minutes < 60) {
        return `${minutes}m ${remainingSeconds}s`;
      }
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
    },
  },
  async mounted() {
    this.data = {};
    await this.update();
    this.interval = setInterval(() => this.update(), 30000);
    this.seconds_interval = setInterval(() => {
      if (this.data.time_left) {
        this.data.time_left = Math.max(this.data.time_left - 1, 0);
      }
    }, 1000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    if (this.start_interval) {
      clearInterval(this.start_interval);
      this.start_interval = null;
    }
    if (this.seconds_interval) {
      clearInterval(this.seconds_interval);
      this.seconds_interval = null;
    }
  },

  methods: {
    async update() {
      try {
        this.data = await this.$ctforge.api.get(`/instancer/${this.name}/status`);
      } catch (e) {
        if (e.status_code === 409) {
          // challenge does not support instances: hide the instancer
          clearInterval(this.interval);
          // hack!
          document.querySelector('#instancer').parentNode.style.display = 'none';
          document.querySelector('.column.is-two-thirds').classList.remove('is-two-thirds');
        } else {
          this.notify(e.message, 'is-danger');
        }
      }
    },
    poll() {
      this.loading = true;
      this.start_interval = setInterval(() => {
        this.update();
        // Only wait for essential fields (conn_info_format is optional and can be null)
        const hasEssentialData = this.data.name != null && this.data.conn_info != null && this.data.time_left != null;
        if (!this.isStopped && hasEssentialData) {
          clearInterval(this.start_interval);
          this.start_interval = null;
          this.loading = false;
        }
      }, 1000);
    },
    async start() {
      try {
        await this.$ctforge.api.post(`/instancer/${this.name}/start`);
        this.poll();
      } catch (e) {
        this.notify(e.message, 'is-danger');
        this.loading = false;
      }
    },
    async destroy() {
      try {
        this.loading = true;
        await this.$ctforge.api.post(`/instancer/${this.name}/destroy`);
        await new Promise((r) => setTimeout(r, 2000));
        await this.update();
        this.loading = false;
      } catch (e) {
        this.notify(e.message, 'is-danger');
        this.loading = false;
      }
    },
    async refresh() {
      try {
        this.loading = true;
        await this.$ctforge.api.post(`/instancer/${this.name}/refresh`);
        await this.update();
        this.loading = false;
      } catch (e) {
        this.notify(e.message, 'is-danger');
        this.loading = false;
      }
    },
  },
};
</script>

<style>
  .is-clearfix {
    clear: both;
  }
  .status{
  display:inline-block;
  width:10px;
  height:10px;
  border-radius:50%;
  vertical-align:middle;
  position:relative;
  transform:translateY(-20%);
  }
  .status.ok {
    background:#28a745;
  }
  .status.warning {
    background:#ffca28;
  }
  .status.error {
    background:#e53935;
  }

/* pulse ring */
.status::after{
  content:"";
  position:absolute;
  left:50%;
  top:50%;
  transform:translate(-50%,-50%);
  width:100%;
  height:100%;
  border-radius:50%;
  background:inherit;
  opacity:0.6;
  animation:pulse 1.6s infinite;
}

@keyframes pulse{
  0%   { transform:translate(-50%,-50%) scale(1);   opacity:0.7; }
  70%  { transform:translate(-50%,-50%) scale(2.2); opacity:0;   }
  100% { transform:translate(-50%,-50%) scale(2.4); opacity:0;   }
}
</style>
